import coreAPIInstance from "./coreApiInstance";

export const typesenseAPIs = {
  getTypesenseStreams: ({ payload }) => coreAPIInstance.post(`/api/v1/typesense/filter.streams`, payload),
  getTypesenseClips: ({ payload: { headers, ...requestPayload } }) =>
    coreAPIInstance.post(`/api/v1/typesense/filter.clips`, requestPayload, { headers }),
};
